import classNames from 'classnames';
import React, { useEffect, useRef, useState } from 'react';
import RichText from '@/components/atoms/rich-text/rich-text';
import Typography from '@/components/atoms/typography/typography';
import Link from '@/components/utilities/link/link';
import styles from './truncated-text.module.scss';

export interface TruncatedTextProps {
  /** Additional class name for styling */
  className?: string;
  /** Force show more link to render regardless of content height */
  forceShowMoreLink?: boolean;
  /** Maximum lines before truncation occurs */
  maxLines?: number;
  /** Callback when "Show more" is clicked */
  onShowMoreClick: () => void;
  /** The content to be truncated */
  richText: string;
  /** Show more link text */
  showMoreText: string;
}

const TruncatedText = ({
  className,
  forceShowMoreLink = false,
  maxLines = 3,
  onShowMoreClick,
  richText,
  showMoreText,
}: TruncatedTextProps) => {
  const contentRef = useRef<HTMLDivElement>(null);
  const [isTruncated, setIsTruncated] = useState(false);

  useEffect(() => {
    if (!contentRef.current) return;

    setIsTruncated(
      contentRef.current.scrollHeight > contentRef.current.clientHeight,
    );
  }, [richText, maxLines]);

  return (
    <div className={classNames(styles.component, className)}>
      <RichText
        ref={contentRef}
        className={styles.content}
        style={{
          WebkitLineClamp: maxLines,
        }}
        text={richText}
      />

      {(isTruncated || forceShowMoreLink) && (
        <Link
          className={styles.link}
          onClick={event => {
            event?.preventDefault();
            event?.stopPropagation();
            onShowMoreClick();
          }}
        >
          <Typography tagStyle="bodyMedium">{showMoreText}</Typography>
        </Link>
      )}
    </div>
  );
};

export default TruncatedText;
